shadow$provide[494] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Factory:{enumerable:true, get:function() {
  return Factory;
}}});
var require$_DOT__DOT__SLASH_graph = require("../graph");
var Block = require("../block");
var Visualize = require("../visualize");
class Factory {
  constructor(language, fetch, config) {
    this.language = language;
    this.fetch = fetch;
    this.config = config;
    this.graph();
  }
  pipe(name, uniforms, namespace, defines) {
    if (name instanceof Factory) {
      this._concat(name);
    } else if (name != null) {
      this._call(name, uniforms, namespace, defines);
    }
    return this;
  }
  call(name, uniforms, namespace, defines) {
    return this.pipe(name, uniforms, namespace, defines);
  }
  require(name, uniforms, namespace, defines) {
    if (name instanceof Factory) {
      this._import(name);
    } else if (name != null) {
      this.callback();
      this._call(name, uniforms, namespace, defines);
      this.end();
    }
    return this;
  }
  import(name, uniforms, namespace, defines) {
    return this.require(name, uniforms, namespace, defines);
  }
  split() {
    this._group("_combine", true);
    return this;
  }
  fan() {
    this._group("_combine", false);
    return this;
  }
  isolate() {
    this._group("_isolate");
    return this;
  }
  callback() {
    this._group("_callback");
    return this;
  }
  next() {
    this._next();
    return this;
  }
  pass() {
    const pass = this._stack[2].end;
    this.end();
    this._state.end = this._state.end.concat(pass);
    return this;
  }
  end() {
    const [sub, main] = Array.from(this._exit());
    const {op} = sub;
    if (this[op]) {
      this[op](sub, main);
    }
    return this;
  }
  join() {
    return this.end();
  }
  graph() {
    while ((this._stack != null ? this._stack.length : undefined) > 1) {
      this.end();
    }
    if (this._graph) {
      this._tail(this._state, this._graph);
    }
    const graph = this._graph;
    this._graph = new require$_DOT__DOT__SLASH_graph.Graph();
    this._state = new State();
    this._stack = [this._state];
    return graph;
  }
  compile(namespace) {
    if (namespace == null) {
      namespace = "main";
    }
    return this.graph().compile(namespace);
  }
  link(namespace) {
    if (namespace == null) {
      namespace = "main";
    }
    return this.graph().link(namespace);
  }
  serialize() {
    return Visualize.serialize(this._graph);
  }
  empty() {
    return this._graph.nodes.length === 0;
  }
  _concat(factory) {
    let block;
    if (factory._state.nodes.length === 0) {
      return this;
    }
    this._tail(factory._state, factory._graph);
    try {
      block = new Block.Isolate(factory._graph);
    } catch (error) {
      if (this.config.autoInspect) {
        Visualize.inspect(error, this._graph, factory);
      }
      throw error;
    }
    this._auto(block);
    return this;
  }
  _import(factory) {
    let block;
    if (factory._state.nodes.length === 0) {
      throw "Can't import empty callback";
    }
    this._tail(factory._state, factory._graph);
    try {
      block = new Block.Callback(factory._graph);
    } catch (error) {
      if (this.config.autoInspect) {
        Visualize.inspect(error, this._graph, factory);
      }
      throw error;
    }
    this._auto(block);
    return this;
  }
  _combine(sub, main) {
    for (const to of Array.from(sub.start)) {
      for (const from of Array.from(main.end)) {
        from.connect(to, sub.multi);
      }
    }
    main.end = sub.end;
    return main.nodes = main.nodes.concat(sub.nodes);
  }
  _isolate(sub, _main) {
    if (sub.nodes.length) {
      let block;
      const subgraph = this._subgraph(sub);
      this._tail(sub, subgraph);
      try {
        block = new Block.Isolate(subgraph);
      } catch (error) {
        if (this.config.autoInspect) {
          Visualize.inspect(error, this._graph, subgraph);
        }
        throw error;
      }
      return this._auto(block);
    }
  }
  _callback(sub, _main) {
    if (sub.nodes.length) {
      let block;
      const subgraph = this._subgraph(sub);
      this._tail(sub, subgraph);
      try {
        block = new Block.Callback(subgraph);
      } catch (error) {
        if (this.config.autoInspect) {
          Visualize.inspect(error, this._graph, subgraph);
        }
        throw error;
      }
      return this._auto(block);
    }
  }
  _call(name, uniforms, namespace, defines) {
    const snippet = this.fetch(name);
    snippet.bind(this.config, uniforms, namespace, defines);
    const block = new Block.Call(snippet);
    return this._auto(block);
  }
  _subgraph(sub) {
    const subgraph = new require$_DOT__DOT__SLASH_graph.Graph(null, this._graph);
    subgraph.adopt(sub.nodes);
    return subgraph;
  }
  _tail(state, graph) {
    let tail = state.end.concat(state.tail);
    tail = tail.filter((node, i) => tail.indexOf(node) === i);
    if (tail.length > 1) {
      tail = new Block.Join(tail);
      tail = [tail.node];
      this._graph.add(tail);
    }
    graph.tail = tail[0];
    state.end = tail;
    state.tail = [];
    if (!graph.tail) {
      throw new Error("Cannot finalize empty graph");
    }
    graph.compile = namespace => {
      if (namespace == null) {
        namespace = "main";
      }
      try {
        return graph.tail.owner.compile(this.language, namespace);
      } catch (error) {
        if (this.config.autoInspect) {
          graph.inspect(error);
        }
        throw error;
      }
    };
    graph.link = namespace => {
      if (namespace == null) {
        namespace = "main";
      }
      try {
        return graph.tail.owner.link(this.language, namespace);
      } catch (error) {
        if (this.config.autoInspect) {
          graph.inspect(error);
        }
        throw error;
      }
    };
    graph.export = (layout, depth) => {
      return graph.tail.owner.export(layout, depth);
    };
    return graph.inspect = (message = null) => Visualize.inspect(message, graph);
  }
  _group(op, multi) {
    this._push(op, multi);
    this._push();
    return this;
  }
  _next() {
    const sub = this._pop();
    this._state.start = this._state.start.concat(sub.start);
    this._state.end = this._state.end.concat(sub.end);
    this._state.nodes = this._state.nodes.concat(sub.nodes);
    this._state.tail = this._state.tail.concat(sub.tail);
    return this._push();
  }
  _exit() {
    this._next();
    this._pop();
    return [this._pop(), this._state];
  }
  _push(op, multi) {
    this._stack.unshift(new State(op, multi));
    return this._state = this._stack[0];
  }
  _pop() {
    let left;
    this._state = this._stack[1];
    if (this._state == null) {
      this._state = new State();
    }
    return (left = this._stack.shift()) != null ? left : new State();
  }
  _auto(block) {
    if (block.node.inputs.length) {
      return this._append(block);
    } else {
      return this._insert(block);
    }
  }
  _append(block) {
    let end;
    const {node} = block;
    this._graph.add(node);
    for (end of Array.from(this._state.end)) {
      end.connect(node);
    }
    if (!this._state.start.length) {
      this._state.start = [node];
    }
    this._state.end = [node];
    this._state.nodes.push(node);
    if (!node.outputs.length) {
      this._state.tail.push(node);
    }
  }
  _prepend(block) {
    let start;
    const {node} = block;
    this._graph.add(node);
    for (start of Array.from(this._state.start)) {
      node.connect(start);
    }
    if (!this._state.end.length) {
      this._state.end = [node];
    }
    this._state.start = [node];
    this._state.nodes.push(node);
    if (!node.outputs.length) {
      this._state.tail.push(node);
    }
  }
  _insert(block) {
    const {node} = block;
    this._graph.add(node);
    this._state.start.push(node);
    this._state.end.push(node);
    this._state.nodes.push(node);
    if (!node.outputs.length) {
      return this._state.tail.push(node);
    }
  }
}
class State {
  constructor(op = null, multi, start, end, nodes, tail) {
    this.op = op;
    if (multi == null) {
      multi = false;
    }
    this.multi = multi;
    if (start == null) {
      start = [];
    }
    this.start = start;
    if (end == null) {
      end = [];
    }
    this.end = end;
    if (nodes == null) {
      nodes = [];
    }
    this.nodes = nodes;
    if (tail == null) {
      tail = [];
    }
    this.tail = tail;
  }
}

};